import { PayScheduleDetail } from '@xemplo/gp-types';

import { formatDaysAfterPayDay, formatDaysBeforePayDay } from '../shared/card-helpers';

function formatBankFileUploadDue(daysBefore: number | null, time: string | null): string {
  if (daysBefore === null) return '';
  return formatDaysBeforePayDay(daysBefore, time);
}

function formatBankFileDated(
  isBankFileUploadDatePayDay: boolean | null,
  bankFileDateInDays: number | null
): string {
  if (isBankFileUploadDatePayDay === null) return '-';

  if (isBankFileUploadDatePayDay) return 'Pay Day';

  return formatDaysAfterPayDay(bankFileDateInDays);
}

export function getFieldsArray(payScheduleData: PayScheduleDetail) {
  const {
    isInvoiceNeeded,
    isUploadBankFile,
    bankFileUploadDueInDays,
    bankFileUploadDueTime,
    isBankFileUploadDatePayDay,
    bankFileDateInDays,
  } = payScheduleData;

  const fields = [
    {
      id: 'generate-invoice',
      label: 'Generate Invoice',
      value: isInvoiceNeeded ? 'Yes' : 'No',
    },
    {
      id: 'psp-upload-bank-file',
      label: 'PSP Upload Bank File',
      value: isUploadBankFile ? 'Yes' : 'No',
    },
  ];

  if (isUploadBankFile) {
    fields.push(
      {
        id: 'bank-file-upload-due',
        label: 'Bank File Upload Due',
        value: formatBankFileUploadDue(bankFileUploadDueInDays, bankFileUploadDueTime),
      },
      {
        id: 'bank-file-dated',
        label: 'Bank File Dated',
        value: formatBankFileDated(isBankFileUploadDatePayDay, bankFileDateInDays),
      }
    );
  }

  return fields;
}
